import styled, { css } from 'styled-components';

const darkBlueGradient = 'radial-gradient(circle, #2E93EE 1.9%, #2E93EE 5.89%, #415ACA 40.83%, #5421A5 77.87%, #551CA2 83%, #2E1451 116.37%)';
const lightBlueGradient = 'radial-gradient(circle, #0070D1 1.9%, #0473D3 5.89%, #258AE0 40.83%, #419EEB 77.87%, #4DA5EF 83%, #74C1FF 116.37%)';

export const GradientButton = styled.button`
  ${({
    theme, $width, $size, $variant, $gradientVariant = 'darkBlueGradient',
  }) => css`
    align-items: center;
    border-radius: 30px;
    border: none;
    cursor: pointer;
    display: flex;
    gap: 16px;
    justify-content: center;
    padding: 12px 24px;

    &:disabled {
      background-image: none;
      background-color: ${({ theme }) => theme.v2.colors.neutral.highLight};
      cursor: not-allowed;
    }

    ${$size === 'lg' && css`
      padding: 18px 24px;
    `}

    ${$size === 'md' && css`
      padding: 14px 24px;
    `}

    ${$size === 'sm' && css`
      padding: 4px 16px;
    `}    

    ${$width === 'fit' && css`
      min-width: fit-content;
    `}

    ${$width === 'full' && css`
      flex: 1;
      max-width: 100%;
      width: 100%;
    `}

    ${$variant === 'primary' && css`
      --mouse-x: 0;
      --mouse-y: 50;
      background-image: ${$gradientVariant === 'darkBlueGradient' ? darkBlueGradient : lightBlueGradient};
      background-position: calc((100 - var(--mouse-x, 0)) * 1%) calc((100 - var(--mouse-y, 0)) * 1%);
      background-size: 200% 200%;
    `}

    ${$variant === 'secondary' && css`
      background-color: ${theme.v2.colors.neutral.highPure};
    `}

    ${$variant === 'tertiary' && css`
      background-color: ${theme.v2.colors.neutral.highPure};
    `}

    ${$variant === 'quaternary' && css`
      --mouse-x: 0;
      --mouse-y: 50;
      background-image: radial-gradient(circle, #0070D1 1.36%, #0070D1 7.48%, #0271D2 13.6%, #0473D3 19.72%, #0775D4 25.85%, #0B78D5 31.97%, #107BD7 38.09%, #1680DA 44.21%, #1D84DC 50.33%, #258AE0 56.46%, #2D90E3 62.58%, #3796E7 68.7%, #419EEB 74.82%, #4DA5EF 80.94%, #59AEF4 87.07%, #66B7F9 93.19%, #74C1FF 99.31%);

      background-position: calc((100 - var(--mouse-x, 0)) * 1%) calc((100 - var(--mouse-y, 0)) * 1%);
      background-size: 200% 200%;
    `}

    ${$variant === 'quinary' && css`
      background: linear-gradient(90deg, #20CAC1 0%, #0695EC 100%);
    `}

    ${$variant === 'agentsFactory' && css`
      background: linear-gradient(25deg, #0072ff 0%, #00c6ff 50%, #00c6ff 100%);
    `}
  `}
`;

export const GradientButtonLabel = styled.span`
  ${({
    theme, $size, $variant, $disabled,
  }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    padding: 0;

    ${$size === 'lg' && css`
      font-size: ${theme.v2.font.sizes.xs};
    `}

    ${$size === 'md' && css`
      font-size: ${theme.v2.font.sizes.xs};
    `}
    
    ${$variant === 'primary' && css`
      color: ${theme.v2.colors.neutral.highPure};
    `}

    ${$variant === 'quaternary' && css`
      color: ${theme.v2.colors.neutral.highPure};
    `}

    ${$variant === 'agentsFactory' && css`
      color: ${theme.v2.colors.neutral.highPure};
    `}
    
    ${$variant === 'secondary' && css`
      --mouse-x: 0;
      --mouse-y: 50;
      align-items: center;
      background-image: radial-gradient(circle, #2E93EE 1.9%, #2E93EE 5.89%, #415ACA 40.83%, #5421A5 77.87%, #551CA2 83%, #2E1451 116.37%);
      background-position: calc((100 - var(--mouse-x, 0)) * 1%) calc((100 - var(--mouse-y, 0)) * 1%);
      background-size: 200% 200%;
    `}

    ${$variant === 'tertiary' && css`
      background: linear-gradient(272deg, #0070D1 1.36%, #0070D1 7.48%, #0271D2 13.6%, #0473D3 19.72%, #0775D4 25.85%, #0B78D5 31.97%, #107BD7 38.09%, #1680DA 44.21%, #1D84DC 50.33%, #258AE0 56.46%, #2D90E3 62.58%, #3796E7 68.7%, #419EEB 74.82%, #4DA5EF 80.94%, #59AEF4 87.07%, #66B7F9 93.19%, #74C1FF 99.31%);
    `}

    ${($variant === 'secondary' || $variant === 'tertiary') && css`
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    `}

    ${$disabled && css`
      color: ${theme.v2.colors.neutral.lowLight};
    `}       
  `}
`;
